import { useDispatch, useSelector } from 'react-redux'
import './UserFeed.css'
import React, { useEffect, useState, useRef } from 'react'
import { getUserFeed } from '../../../actions/UserFeedAction';
import UserDetail from '../../User/UserDetail';
import { generateValueList } from '../../../tools/generateValueList';
import { MdFilterAltOff } from 'react-icons/md';
import { BiFilterAlt, BiTrash } from 'react-icons/bi';
import InfiniteScrollLoader from '../ItemFeed/InfiniteScrollLoader';
import { saveFilters, loadFilters, clearSavedFilters } from '../../../utils/filterPersistence';
import { TbFaceIdError } from 'react-icons/tb';

const UserFeed = ( {userFeedType}) => {
  
    const dispatch = useDispatch();
    // Can I combine the following 2 lines somehow?  
    const {user} = useSelector((state)=> state.authReducer.authData);
    const {loading: authDataLoading} = useSelector((state)=> state.authReducer);
    const {userFeed, loading: userFeedLoading, hasMore, totalItems} = useSelector((state)=> state.userFeedReducer);
    const [page, setPage] = useState(0);

    const FILTER_KEY = 'userFeed_filters'
    const filtersObj = {
        username: null,
        keyword: null,
        theme: null,
        subscribed: false,
        followed: false,
        value: null,
        sortBy: null
    }
    const [filters, setFilters] = useState(() => loadFilters(FILTER_KEY, filtersObj, user._id));

    useEffect(() => {
        saveFilters(FILTER_KEY, filters, user._id);
    }, [filters]);

    useEffect (()=> {
        if (!authDataLoading) {
            const savedFilters = loadFilters(FILTER_KEY, filtersObj, user._id)
            dispatch(getUserFeed(user._id, JSON.stringify(savedFilters), 0));
            const loadValueList = async() => {
                const output = await generateValueList("userFeedFilter");
                // Still trying to figure out what's going on here.  Getting null error for gvl_dropdown_container
                if(document.getElementById("gvl_dropdown_container")){
                    document.getElementById("gvl_dropdown_container").innerHTML = output;
                    document.getElementById("gvl_dropdown").addEventListener("change", (e)=>handleChange(e));
                }                    
            };
            user.userType !== 2 && loadValueList();
        }
    }, [authDataLoading])

    const hasMoreRef = useRef(hasMore);
    const isFetchingRef = useRef(false);
    const loadingRef = useRef(userFeedLoading);
    const pageRef = useRef(page);
    const filtersRef = useRef(filters)
    
    useEffect(() => { hasMoreRef.current = hasMore; }, [hasMore]);
    useEffect(() => { loadingRef.current = userFeedLoading; }, [userFeedLoading]);
    useEffect(() => { pageRef.current = page; }, [page]);
    useEffect(() => {filtersRef.current = filters; }, [filters]);
    
    useEffect(() => {
        const appContainer = document.querySelector('.App');
            
        const handleScroll = () => {
            const nearBottom =
                appContainer.scrollHeight - appContainer.scrollTop - appContainer.clientHeight < 200;
                            
            if (nearBottom && hasMoreRef.current && !isFetchingRef.current) {
                isFetchingRef.current = true
                const nextPage = pageRef.current + 1;
                setPage(nextPage);
                dispatch(getUserFeed(user._id, JSON.stringify(filtersRef.current), nextPage)).finally(() => {
                    isFetchingRef.current = false;
                });
            }
        };
        
        appContainer.addEventListener('scroll', handleScroll);
        return () => appContainer.removeEventListener('scroll', handleScroll);
    }, []);

    const handleChange = (e) => {
    // console.log(document.getElementById("subscribed").checked);
    setFilters({...filters, [e.target.name]: e.target.value})
    }

    const handleChecked = (e) => {
    setFilters({...filters, [e.target.name]: e.target.checked})
    }

    const handleSubmitFilters = (e) => {
    e.preventDefault();
    setPage(0)
    dispatch(getUserFeed(user._id, JSON.stringify(filters), 0))
    }
    const clearFilters = () => {
        clearSavedFilters(FILTER_KEY, user._id)
        setFilters(filtersObj);
        setPage(0)
        document.querySelectorAll('#userFeed_filter_bar input[type="text"]').forEach(input => {
            input.value = '';
        });
        document.querySelectorAll('#userFeed_filter_bar input[type="checkbox"]').forEach(input => {
            input.checked = false;
        });
        dispatch(getUserFeed(user._id, JSON.stringify(filtersObj), 0));
    };

    function NoUsers() {
        var noItemsText = (
            <>
                Check your Filter and Sort options in the <span className="General-inline-icon"><BiFilterAlt /></span> menu above and try adjusting your filters.
            </>
        );
        var userText = "";
        switch(user.userType) {
            case 0:
            case 1:
                userText = "Groups";
                break;
            case 2:
                userText = "Authors";
                break;
        }
        return (
            <div className='General-nr-container'>
                <span className='General-nr-top'>You don't have any {userText} to view.</span>
                <TbFaceIdError size='30'/>
                <div className='General-nr-hint'>{noItemsText}</div>
            
            </div>
        )
    }

    return (
        <>
            <div className="General-filter-bar General-hidden" id="userFeed_filter_bar">
                
                <form action="" className='FlexColumn General-filter-form' onSubmit={handleSubmitFilters}>
                    <span className='FlexRow General-filter-form'>
                        <span className='General-filter-key'>Username:</span>
                        <div style={{ position: 'relative', width: '77%' }}>
                            <input
                            type="text"
                            placeholder="Filter by user name..."
                            name="username"
                            className='General-input'
                            value={filters.username || ''}
                            onChange={handleChange}
                            style={{ paddingRight: '24px', width: '100%' }}
                            />
                            {filters.username && (
                            <BiTrash
                                onClick={() => setFilters({ ...filters, username: null })}
                                style={{ 
                                position: 'absolute', 
                                marginLeft: 'auto', 
                                top: '50%', 
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: '#6b7280'
                                }}
                            />
                            )}
                      </div>
                    </span>
                    <span className='FlexRow General-filter-form'>
                        <span className='General-filter-key'>Keyword:</span>
                        <div style={{ position: 'relative', width: '77%' }}>
                            <input
                            type="text"
                            placeholder="Filter by keyword..."
                            name="keyword"
                            className='General-input'
                            value={filters.keyword || ''}
                            onChange={handleChange}
                            style={{ paddingRight: '24px', width: '100%' }}
                            />
                            {filters.keyword && (
                            <BiTrash
                                onClick={() => setFilters({ ...filters, keyword: null })}
                                style={{ 
                                position: 'absolute', 
                                marginLeft: 'auto', 
                                top: '50%', 
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: '#6b7280'
                                }}
                            />
                            )}
                      </div>
                    </span>
                    {userFeedType === 2 &&
                        <div className='FlexColumn General-filter-form'>
                            <span className='FlexRow General-filter-form'>
                                <span className='General-filter-key'>Value:</span>
                                <div className="gvl-dropdown-container" id="gvl_dropdown_container"></div>
                            </span>
                        </div>
                    }
                    {user.userType === 2 && (
                        <div className='FlexColumn General-filter-form'>
                            <span className='FlexRow General-filter-form'>
                                <span className='General-filter-key'>Sort By:</span>
                                <div style={{ position: 'relative', width: '95%' }}>
                                <select 
                                    name='sortBy' 
                                    className='General-input'
                                    onChange={handleChange}
                                    value={filters.sortBy || ''}
                                >
                                    <option defaultValue={'authoredData'} value='authoredData'>By Authored Data</option>
                                    <option value='dataStamps'>By Data Stamps</option>
                                </select>
                                </div>
                            </span>
                        </div>
                    )}
                    {user.userType !== 0 
                        ? user.userType === 1 ? <div className='FlexColumn General-filter-form'>
                            <span className='FlexRow General-filter-form'>
                                <span className='General-filter-key'>Include Subscribed to me:</span>
                                <input id="subscribed" name="subscribed" type="checkbox" onClick={handleChecked} checked={filters.subscribed || false} />
                            </span>
                        </div> :
                            <span className='FlexRow General-filter-form'>
                            <span className='General-filter-key'>Include Subscribed:</span>
                            <input id="subscribed" name="subscribed" type="checkbox" onClick={handleChecked} checked={filters.subscribed || false} />
                        </span>
                        : <div className='FlexColumn General-filter-form'>
                            <span className='FlexRow General-filter-form'>
                                <span className='General-filter-key'>Include Followed:</span>
                                <input id="followed" name="followed" type="checkbox" onClick={handleChecked} checked={filters.followed || false}/>
                            </span>
                        </div>
                    }
                    
                    
                    <div className='FlexRow General-filter-form items-center flex justify-center'>
                        <button className='button signupButton' type='submit'>
                            Apply Filters
                        </button>
                        <button 
                            className='button signupButton' 
                            type='button' 
                            onClick={clearFilters}
                            title='Clear all filters'
                        >
                          <MdFilterAltOff />
                        </button>
                     </div>   
                </form>
            </div>
            <div className='feed-result-count'>
                {userFeedLoading ?
                'Loading':
                `Search returned ${totalItems} ${
                    userFeedType === 1 ? (totalItems === 1 ? 'Author' : 'Authors')
                    : userFeedType === 2 ? (totalItems === 1 ? 'Group' : 'Groups')
                    : (totalItems === 1 ? 'User' : 'Users')
                }`}
            </div>
            <div className='UserFeed'>
                {userFeed && userFeed.length > 0 
                ? userFeed.map((user, id) => {
                    return <UserDetail data={user} userKey={id} key={id}/>
                })
                : <NoUsers />
                }
            </div>
            {userFeed && userFeed.length > 0  && (
                <InfiniteScrollLoader hasMore={hasMore} />
            )}
        </>
    
  )
}

export default UserFeed